import React from "react"
import { twMerge } from "tailwind-merge"

const H1 = props => {
  return (
    <h1
      className={twMerge([
        "mb-2 mt-0 border-b border-slate-900 pb-2 text-2xl font-extralight text-slate-900",
        props.className,
      ])}
    >
      {props.children}
    </h1>
  )
}
const H2 = props => {
  return (
    <h2
      className={twMerge([
        "mb-2 mt-6 text-lg font-bold text-slate-800",
        props.className,
      ])}
    >
      {props.children}
    </h2>
  )
}
const H3 = props => {
  return (
    <h3
      className={twMerge([
        "mb-1 mt-3 text-base font-semibold text-slate-800",
        props.className,
      ])}
    >
      {props.children}
    </h3>
  )
}
const P = props => {
  return (
    <p className={twMerge(["mb-4 text-sm text-slate-700", props.className])}>
      {props.children}
    </p>
  )
}
// used in appnoteblock and productblock
const H4 = props => {
  return (
    <h4
      className={twMerge([
        "mb-1.5 text-sm font-semibold text-slate-800",
        props.className,
      ])}
    >
      {props.children}
    </h4>
  )
}

// elements
const Citation = props => {
  return (
    <div className={twMerge(["citation", props.className])}>
      {props.children}
    </div>
  )
}

const DangerCitation = props => {
  return (
    <div
      className={twMerge([
        "mb-1.5 mt-2.5 max-w-md text-xs font-extralight text-slate-400",
        props.className,
      ])}
      dangerouslySetInnerHTML={{
        __html: props.content,
      }}
    />
  )
}

const CTA = props => {
  return (
    <p
      className={twMerge([
        "my-4 -ml-10 max-w-md rounded-r-md bg-slate-200 py-2.5 pl-10 pr-3 font-semibold text-slate-700",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}
const Disclaimer = props => {
  return (
    <div className={twMerge(["disclaimer", props.className])}>
      {props.children}
    </div>
  )
}

// containers
const TextColumns = props => {
  return (
    <div
      className={twMerge([
        "text-justify md:columns-2 md:gap-x-8",
        props.className,
      ])}
    >
      {props.children}
    </div>
  )
}

const Caption = props => {
  return (
    <div
      className={twMerge([
        "mb-4 flex justify-start border-t border-blue-500",
        props.image && "mx-auto -mt-2 w-3/4",
        props.table && "mt-2",
        props.className,
      ])}
    >
      <span className="mr-2 text-xs font-normal italic text-slate-800">
        {props.fig && "fig."}
        {props.table && "table."}
        {props.fig || props.table}
      </span>
      <span className="text-xs font-extralight leading-tight text-slate-600">
        {props.children}
      </span>
    </div>
  )
}

// tables
const AppTable = props => {
  return (
    <div className="mb-4 mt-4 overflow-x-auto">
      <table className="appTableStyles">
        {props.caption && (
          <caption className=" mb-2 border-b border-blue-500">
            <span className="mr-2 text-xs font-normal italic text-slate-800">{`Table.${props.caption[0]}`}</span>
            <span
              className="text-xs font-extralight leading-tight text-slate-600"
              dangerouslySetInnerHTML={{ __html: props.caption[1] }}
            ></span>
          </caption>
        )}
        {props.children}
      </table>
    </div>
  )
}

//functions
const Trunc = (str, limit) => {
  if (str.length > limit) {
    const elip = "..."
    const rslt = str.slice(0, limit - 1).concat("", elip)
    return rslt
  } else {
    return str
  }
}

export {
  H1,
  H2,
  H3,
  H4,
  P,
  Citation,
  DangerCitation,
  CTA,
  Caption,
  AppTable,
  TextColumns,
  Disclaimer,
  Trunc,
}
